import { makeStyles, tokens } from '@fluentui/react-components';

export const useNavigationBarStyles = makeStyles({
    navbar: {
        backgroundColor: tokens.colorBrandBackground,
        borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
        padding: '0 16px',
        height: '48px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    brand: {
        display: 'flex',
        alignItems: 'center',
        gap: '16px',
    },
    title: {
        color: tokens.colorNeutralForegroundOnBrand,
        margin: '0',
        fontSize: '18px',
        fontWeight: '600',
    },
    navActions: {
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
    },
    avatar: {
        cursor: 'pointer',
        border: `2px solid ${tokens.colorNeutralForegroundOnBrand}`,
        marginRight: '0',
    },
    supportButton: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '36px',
        height: '36px',
        color: tokens.colorNeutralForegroundOnBrand,
        backgroundColor: 'transparent',
        cursor: 'pointer',
        border: 'none',
        borderRadius: '4px',
        ':hover': {
            backgroundColor: tokens.colorBrandBackgroundHover,
        },
    },
    panelOverlay: {
        position: 'fixed',
        top: '48px',
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999,
    },
    panelSurface: {
        position: 'fixed',
        right: 0,
        width: '460px',
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: tokens.colorNeutralBackground1,
        boxShadow: tokens.shadow64,
        zIndex: 1000,
    },
    supportDrawer: {
        top: '48px',
        height: 'calc(100vh - 48px)',
    },
    panelHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '8px 8px 0 24px',
    },
    panelTitle: {
        margin: 0,
        fontSize: '20px',
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    supportPanelBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px 24px',
        flex: 1,
        overflowY: 'auto',
    },
    emailRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    supportPanelText: {
        color: tokens.colorNeutralForeground2,
        lineHeight: '1.5',
    },
    supportPanelFooter: {
        display: 'flex',
        justifyContent: 'flex-start',
        padding: '16px 24px',
        borderTop: `1px solid ${tokens.colorNeutralStroke1}`,
        marginTop: 'auto',
    },
});
